"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const head_1 = __importDefault(require("next/head"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
/** A fundamental component which handles page animations for you */
const Page = (props) => {
    const { children, title } = props;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title && (react_1.default.createElement(head_1.default, null,
            react_1.default.createElement("title", null, title))),
        react_1.default.createElement("div", Object.assign({}, primitiveProps), children)));
};
exports.default = withJourney_1.default('j-page', Page, {
    wrapsHref: false,
    collapseInModal: 'skipped',
});
